import { DatePicker, Popover, Select } from "antd";
import { Filter } from "lucide-react";
import { useMemo, useState } from "react";
import { Button } from "../components/ui/button";
import useSWR from "swr";
import { fetcher } from "../util/axiosConfig";

interface ActivityLogsFilterProps {
  onChange: (filters: any) => void
}

const { RangePicker } = DatePicker;

function ActivityLogsFilter({ onChange }: ActivityLogsFilterProps) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    from: '',
    to: '',
    entityType: '',
    action: ''
  });

  const { data: actionsData, isLoading } = useSWR('newAdmin/logs/actions', fetcher);
  const { data: entityTypesData, isLoading: isEntityTypesLoading } = useSWR('newAdmin/logs/entity-types', fetcher);

  const entityOptions = useMemo(() => {
    return entityTypesData?.data?.map((type: string) => ({
      label: type,
      value: type
    })) || [];
  }, [entityTypesData]);

  const actionOptions = useMemo(() => {
    return actionsData?.data?.map((action: string) => ({
      label: action,
      value: action
    })) || [];
  }, [actionsData]);

  const hidePopover = () => {
    setOpen(false);
  }

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const handleChange = (value: string, name: string) => {
    setFormData({...formData, [name]: value ?? ''});
  }

  const handleApply = () => {
    onChange({ ...formData })
    setOpen(false);
  }

  const Content = () => <div className="space-y-3 w-64 px-1">
    <div className="flex flex-col gap-1">
        <label htmlFor="entity">
            Date Picker
        </label>
        <RangePicker
          size="middle"
          id="entity"
          className="w-full"
          onChange={(date) => {
            if (!date) return;
            setFormData({
                ...formData,
                from: date[0]?.format('DD/MM/YYYY') || '',
                to: date[1]?.format('DD/MM/YYYY') || '',
            })
          }}
        />
    </div>
    <div className="flex flex-col gap-1">
        <label htmlFor="entity">
            Entity
        </label>
        <Select
          size="middle"
          id="entity"
          allowClear
          placeholder="Select Entity"
          className="w-full"
          loading={isEntityTypesLoading}
          disabled={isEntityTypesLoading}
          value={formData.entityType}
          options={entityOptions}
          onChange={(val) => handleChange(val, 'entityType')}
          onClear={() => handleChange('', 'entityType')}
        />
    </div>
    <div className="flex flex-col gap-1">
        <label htmlFor="action">
            Action Type
        </label>
        <Select
          size="middle"
          id="action"
          allowClear
          placeholder="Select Action"
          className="w-full"
          loading={isLoading}
          disabled={isLoading}
          value={formData.action}
          options={actionOptions}
          onChange={(val) => handleChange(val, 'action')}
          onClear={() => handleChange('', 'action')}
        />
    </div>

    <div className="flex items-center justify-between">
      <Button
        variant="secondary"
        className="text-white"
        onClick={hidePopover}
      >
        Cancel
      </Button>
      <Button
        className="text-white"
        onClick={handleApply}
      >
        Apply
      </Button>
    </div>
  </div>
  return (
    <Popover
      placement="bottom"
      title="Filter Activity Logs"
      open={open}
      content={Content}
      onOpenChange={handleOpenChange}
    >
        <Button variant="outline">
            <Filter className="text-primary" />
        </Button>
    </Popover>
  )
}

export default ActivityLogsFilter;